import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    //招聘配置
    list(data)
    {
        return axios.request({
            url: "class/list",
            data,
            method: "post",
        })
    },
    edit(data)
    {
        return axios.request({
            url: "class/edit",
            data,
            method: "post",
        })
    },
    deatillist(data)
    {
        return axios.request({
            url: "class/detail-list",
            data,
            method: "post",
        })
    },
    detailedit(data)
    {
        return axios.request({
            url: "class/detail-edit",
            data,
            method: "post",
        })
    },
    userlist(data)
    {
        return axios.request({
            url: "class/user-list",
            data,
            method: "post",
        })
    },
    adduser(data)
    {
        return axios.request({
            url: "class/add-user",
            data,
            method: "post",
        })
    },
}
